import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useExperiments, useFedopsLogger} from '@wix/yoshi-flow-editor'
import React, {useEffect, useState} from 'react'
import {FormButton} from '../../form-button'
import {ExpressCheckout} from './express-checkout/express-checkout'
import {PaymentProps} from './interfaces'
import {PaymentWidget} from './payment-widget'
import s from './payment.scss'

const PAYMENT_METHODS_WITHOUT_FEE = ['offline']

export const Payment = ({
  paymentRef,
  editing,
  eventId,
  order,
  reservationId,
  onSubmit,
  openCantCompletePaymentModal,
  t,
  isMobile,
  locale,
  isSite,
  isPreview,
  visitorId,
  msid,
  instanceId,
  siteOwnerId,
  navigateToOrder,
  primaryLanguage,
  instance,
  siteStyles,
  isSignedInUser,
  lang,
  updateLayout,
  navigateTo,
  expressCheckout,
  updatePaymentMethod,
  updateOrderInProgress,
}: PaymentProps) => {
  const fedops = useFedopsLogger()
  const {experiments} = useExperiments()
  const [currentPaymentMethodId, setCurrentPaymentMethodId] = useState('')
  const expressCheckoutEnabled = experiments.enabled(ExperimentNames.ExpressCheckout)
  const updatePaymentMethodEnabled = experiments.enabled(ExperimentNames.UpdatePaymentMethodEnabled)

  const selectedPaymentMethodWithoutFee =
    updatePaymentMethodEnabled && PAYMENT_METHODS_WITHOUT_FEE.includes(currentPaymentMethodId)

  const expressCheckoutVisible = expressCheckoutEnabled && !selectedPaymentMethodWithoutFee

  const onPaymentMethodChanged = paymentMethodId => {
    setCurrentPaymentMethodId(paymentMethodId)
    if (updatePaymentMethodEnabled && !isPreview) {
      updatePaymentMethod({paymentMethod: paymentMethodId})
    }
  }

  useEffect(() => {
    fedops?.interactionStarted?.('PAYMENT_WIDGET_LOAD')
  }, [])

  return (
    <div className={s.container}>
      <>
        {expressCheckoutVisible ? (
          <ExpressCheckout
            locale={locale}
            msid={msid}
            visitorId={visitorId}
            instanceId={instanceId}
            siteOwnerId={siteOwnerId}
            instance={instance}
            expressCheckout={expressCheckout}
          />
        ) : null}
        <PaymentWidget
          locale={locale}
          ref={paymentRef}
          eventId={eventId}
          snapshotId={order?.snapshotId}
          reservationId={reservationId}
          isMobile={isMobile}
          isPreview={isPreview}
          openCantCompletePaymentModal={openCantCompletePaymentModal}
          navigateToOrder={navigateToOrder}
          navigateTo={navigateTo}
          isSite={isSite}
          visitorId={visitorId}
          msid={msid}
          instanceId={instanceId}
          primaryLanguage={primaryLanguage}
          siteOwnerId={siteOwnerId}
          externalSubmitButton
          order={order}
          lang={lang}
          instance={instance}
          siteStyles={siteStyles}
          isSignedInUser={isSignedInUser}
          updateLayout={updateLayout}
          fedops={fedops}
          onPaymentMethodChanged={onPaymentMethodChanged}
          currentPaymentMethodId={currentPaymentMethodId}
        />
      </>
      {editing && (
        <div className={s.button}>
          <FormButton
            disabled={updatePaymentMethodEnabled && updateOrderInProgress}
            dataHook={DH.PAYMENT_METHOD_SUBMIT}
            type="submit"
            text={t('mobile.checkout.placeOrder')}
            onClick={() => onSubmit()}
          />
        </div>
      )}
    </div>
  )
}
